/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ic_plane': {
    width: 48,
    height: 48,
    viewBox: '0 0 48 48',
    data: '<path pid="0" d="M35.6 38.4L32 22l7-7c3-3 4-7 3-9-2-1-6 0-9 3l-7 7-16.4-3.6c-1-.2-1.8.2-2.2 1l-.6 1c-.4 1-.2 2 .6 2.6L18 24l-4 6H8l-2 2 6 4 4 6 2-2v-6l6-4 7 10.6c.6.8 1.6 1 2.6.6l1-.4c.8-.6 1.2-1.4 1-2.4v0z" _stroke="#B4C2EA" stroke-opacity=".9" stroke-width="4" stroke-linecap="round" stroke-linejoin="round"/>'
  }
})
